/**
 * Created by cuppi on 2016/11/22.
 */
'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
const JUrlList_1 = require("../unify/JUrlList");
const JDataUnify_1 = require("../unify/JDataUnify");
const JNetworkRoot_1 = require("./JNetworkRoot");
/**
 * 影片接口
 * @memberOf module:network
 */
class JNetworkFilm extends JNetworkRoot_1.default {
    /**
     * 获取热门电影
     * @param page PageModel 分页模型
     * @returns {Promise}
     */
    filmHotfilms(page) {
        if (!page) {
            return new Promise((resolve, reject) => {
                this.prefixPromise(JUrlList_1.filmUrl.jbzHotFilms).then(data => {
                    resolve(JDataUnify_1.default('filmUrl.jbzHotFilms', data));
                }, error => {
                    reject(error);
                });
            });
        }
        else {
            return new Promise((resolve, reject) => {
                this.prefixPromise(JUrlList_1.filmUrl.jbzHotFilmsPage, { page: page.index, size: page.size }).then(data => {
                    resolve(JDataUnify_1.default('filmUrl.jbzHotFilmsPage', data));
                }, error => {
                    reject(error);
                });
            });
        }
    }
    /**
     * 获取热门电影
     * @returns {{terminate, then}|*}
     */
    filmHotfilmsSimple() {
        return new Promise((resolve, reject) => {
            this.prefixPromise(JUrlList_1.filmUrl.jbzHotFilmsSimple).then(data => {
                resolve(JDataUnify_1.default('filmUrl.jbzHotFilmsSimple', data));
            }, error => {
                reject(error);
            });
        });
    }
    /**
     * 获取待映电影
     * @param page 页号
     * @returns {Promise}
     */
    filmWaitfilms(page) {
        if (!page) {
            return new Promise((resolve, reject) => {
                this.prefixPromise(JUrlList_1.filmUrl.jbzWaitFilms).then(data => {
                    resolve(JDataUnify_1.default('filmUrl.jbzWaitFilms', data));
                }, error => {
                    reject(error);
                });
            });
        }
        else {
            return new Promise((resolve, reject) => {
                this.prefixPromise(JUrlList_1.filmUrl.jbzWaitFilmsPage, { page: page.index, size: page.size }).then(data => {
                    resolve(JDataUnify_1.default('filmUrl.jbzWaitFilmsPage', data));
                }, error => {
                    reject(error);
                });
            });
        }
    }
    /**
     * 获取影片详情
     * @param filmId 影片Id
     * @param platform 平台类型(默认使用jbz平台)
     * @returns {Promise}
     */
    filmDetail(filmId, platform = null) {
        if (platform && platform !== 'jbz') {
            return new Promise((resolve, reject) => {
                this.prefixPromise(JUrlList_1.filmUrl.jbzFilmDetailByPartner, { platformFilmId: filmId, platform }).then(data => {
                    resolve(JDataUnify_1.default('filmUrl.jbzFilmDetailByPartner', data));
                }, error => {
                    reject(error);
                });
            });
        }
        else {
            return new Promise((resolve, reject) => {
                this.prefixPromise(JUrlList_1.filmUrl.jbzFilmDetail, { filmId }).then(data => {
                    resolve(JDataUnify_1.default('filmUrl.jbzFilmDetail', data));
                }, error => {
                    reject(error);
                });
            });
        }
    }
    /**
     * 获取影片排片日期列表
     * @param filmId 影片Id
     * @returns {Promise}
     */
    filmDateList(filmId) {
        return new Promise((resolve, reject) => {
            this.prefixPromise(JUrlList_1.filmUrl.jbzFilmDate, { filmId }).then(data => {
                resolve(JDataUnify_1.default('filmUrl.jbzFilmDate', data));
            }, error => {
                reject(error);
            });
        });
    }
    static filmHotfilms(page) {
        return this.instance().filmHotfilms(page);
    }
    static filmHotfilmsSimple() {
        return this.instance().filmHotfilmsSimple();
    }
    static filmWaitfilms(page) {
        return this.instance().filmWaitfilms(page);
    }
    static filmDetail(filmId, platform = null) {
        return this.instance().filmDetail(filmId, platform);
    }
    static filmDateList(filmId) {
        return this.instance().filmDateList(filmId);
    }
}
exports.default = JNetworkFilm;
